export default __webpack_public_path__ + "static/media/Modelhomepage_GIF.8bf07fcd.gif";